import React from 'react';
import { Cell } from 'fixed-data-table-2';
import { useDispatch, useSelector } from 'react-redux';
import { updateMobileDeviceState } from '../../actions/MobileDevicesActions';

// Dedicated, self-contained state cell. We do NOT reuse the shared CSelectCell:
// that component routes changes through the alert status-dialog flow and reads
// state.leaksList.leaksByProject[selectedProject].leaksIds, which is alert-only
// and not guaranteed in the mobile context.
const MobileDeviceStateCell = ({ data, rowIndex, options, notify }) => {
  const dispatch = useDispatch();
  const editMode = useSelector((state) => state.leaksList.user?.editMode);

  if (!options) {
    return <Cell />;
  }

  const device = data[rowIndex];

  const onChange = (event) => {
    const value = Number(event.target.value);
    dispatch(
      updateMobileDeviceState(device, value, (isSuccess) => {
        if (notify) {
          notify(
            isSuccess ? 'Changes saved' : 'Failed to save update',
            isSuccess ? 'success' : 'error'
          );
        }
      })
    );
  };

  return (
    <Cell className='input-cell'>
      <select disabled={!editMode} value={device.state ?? 0} onChange={onChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label || option.DisplayName}
          </option>
        ))}
      </select>
    </Cell>
  );
};

export default MobileDeviceStateCell;
